import React, { useEffect, useRef, useState } from "react";
import OktaSignIn from "@okta/okta-signin-widget";
import "@okta/okta-signin-widget/dist/css/okta-sign-in.min.css";
import { useOktaAuth } from "@okta/okta-react";
import { Redirect } from "react-router-dom";
import { SsoTokensApi, UsersApi } from "../../services/generated-sdk";
import { getAPIConfig } from "../../service-config";
import { connect } from "dva";
import { notification, Spin } from "antd";
import * as _ from "lodash";
import CenterElement from "../common/layout/CenterElement";
import ErrorBoundary from "../wrappers/ErrorBoundary";
import { getOktaSignInConfig } from "../../utils/okta-config";

const OktaSignInWidget = ({ config, onSuccess, onError }) => {
  const widgetRef = useRef();
  useEffect(
    () => {
      try {
        console.log({ config });
        if (widgetRef.current) {
          // return false;
          const widget = new OktaSignIn(config);

          widget
            .showSignInToGetTokens({
              el: widgetRef.current
            })
            .then(onSuccess)
            .catch(onError);

          return () => {
            if (widget) _.get(widget, "remove", () => {}).call();
          };
        }
      } catch (error) {}
    },
    [config, onSuccess, onError]
  );

  return <div ref={widgetRef} />;
};

const OktaSignPage = ({ config, history, ...props }) => {
  const { oktaAuth, authState } = useOktaAuth();
  const [error, setError] = useState("");
  const errorMessage = error ? (
    <span className="error-message">{error}</span>
  ) : null;
  useEffect(
    () => {
      console.log({ OktaSignPage_authState: authState, config, history });
      if (authState.isAuthenticated) {
        loginFromJwt(_.get(authState, "idToken.value"));
      }
    },
    [authState]
  );
  const onSuccess = tokens => {
    oktaAuth.handleLoginRedirect(tokens);
  };

  const onError = err => {
    console.log("error logging in", err);
    setError(error["message"]);
    window.location.reload();
  };

  const loginFromJwt = async jwt => {
    console.log({ jwt, authState, props });
    const ssoApi = new SsoTokensApi();
    console.log({ jwt });
    // const api = new UsersApi(getAPIConfig(jwt));

    try {
      let loginMethodInfo = null;
      if (
        props.app &&
        props.app.ssoInfo &&
        props.app.ssoInfo["company"] != undefined &&
        props.app.ssoInfo["email"] != undefined
      ) {
        loginMethodInfo = props.app.ssoInfo;
      } else {
        loginMethodInfo = await localStorage.getItem("userLoginMethodDetails");
        console.log({ loginMethodInfo });
        // let userEmailFromAuthState = _.get(authState, "idToken.claims.email", null);
        if (loginMethodInfo && loginMethodInfo.length) {
          loginMethodInfo = JSON.parse(loginMethodInfo);
        } else {
          loginMethodInfo = null;
        }
      }
      // console.log({
      //   FINAL_loginMethodInfo: loginMethodInfo,
      //   jwt,
      //   PPP: props.app.ssoInfo
      // });

      if (
        loginMethodInfo["company"] != undefined &&
        loginMethodInfo["email"] != undefined
      ) {
        console.log("now save sso token.............");
        let result = await ssoApi.createSsoToken({
          ssoTokenPayload: {
            company: loginMethodInfo["company"],
            email: loginMethodInfo["email"],
            token: jwt,
            ssoType: "okta"
          }
        });
        console.log("sso token saved.......", { result });
        if (
          result &&
          result.status &&
          result.verifiedUser &&
          result.verifiedUser.jwt &&
          result.verifiedUser.user &&
          result.verifiedUser.user.id
        ) {
          jwt = result.verifiedUser.jwt;
          console.log(
            "updating okta jwt with internal jwt........................"
          );

          try {
            console.log("now clear okta token..........");
            await oktaAuth.tokenManager.clear();
          } catch (error) {
            console.log({ okta_logout_error: error });
          }
        }
      }
    } catch (e) {
      console.log({ sso_token_verify_error: e });
      if (e.json) {
        e.json().then(data => {
          notification.error({
            message: data.message
          });
        });
        history.push("/");
        return;
      }
    }
    try {
      const api = new UsersApi(getAPIConfig(jwt));
      const user = await api.getMyUser();
      console.log({ user, jwt });
      const userAltFormat = {
        jwt,
        user: user
      };
      props.dispatch({
        type: "app/afterLogin",
        payload: {
          user: userAltFormat,
          storeSession: true,
          remember: true,
          callback: success => {
            if (!success) history.push("/okta-login");
            else history.push("/tasks");
          }
        }
      });
      // this.loginTimeOut(100 * 1000);
      //storeUserSession(userAltFormat, expiry);

      //redirectToAccount();
    } catch (e) {
      console.error(e);
    }
  };

  if (authState.isPending) return <Spin tip="Pending..." />;
  return authState.isAuthenticated ? (
    <CenterElement>
      <Spin />
    </CenterElement>
  ) : (
    <ErrorBoundary>
      <OktaSignInWidget
        config={{
          ...getOktaSignInConfig(),
          username: _.get(history, "location.state.email")
        }}
        onSuccess={onSuccess}
        onError={onError}
      />
    </ErrorBoundary>
  );
};

export default connect(({ app }) => ({
  app: app
}))(OktaSignPage);
